import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { DiscountModel } from '@modules/enrolments/models/discount.model';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {HydraCollection} from '@core/api/hydra/hydra-collection';
import { EnrolmentModel } from '../models/course/enrolment.model';
import { map } from 'rxjs/operators';
import { ResourceCollectionFactory } from '../factory/resource-collection-factory';

@Injectable({
  providedIn: 'root'
})
export class EnrolmentApiService extends ApiService {
  readonly resourcePath = 'enrolments';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<EnrolmentModel>> {
    return this.restList(filters);
  }

  get(id: string) {
    return this.http.get(this.resourceUrl +'/'+id+'?expand[]=enrolment:platform:read&expand[]=id&expand[]=timestamps')
  }

  create(enrolment: object, idempotencyKey?: string): Observable<EnrolmentModel> {
    return this.restEnrolmentCreate<EnrolmentModel>(enrolment, idempotencyKey);
  }

  getEnrolments(){
    return this.http.get<any>(this.apiUrl +'/me/enrolment/overview');
  }

  getOrganisationEnrolments(params: Record<string, any> ){

    return this.http.get<any>(this.apiUrl +'/me/enrolment/organisationprofile' + this.formatQueryString(params));
  }

  /**
   * Export all certificate PDFs of an enrolment as a single ZIP (SL-1804).
   * Hits GET /enrolments/{id}/certificates/export — no query params; the backend
   * exports exactly this enrolment's certificates. Returns the full response so the
   * caller can read the 204 (no certificates) status and the Content-Disposition filename.
   */
  exportCertificates(enrolment: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.resourceUrl}/${enrolment}/certificates/export`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  /**
   * Export the certificate PDFs of a single attendee as a ZIP.
   * GET /students/{id}/certificates/export — same response contract as
   * exportCertificates (200 ZIP / 204 empty / 403 / 404).
   */
  exportStudentCertificates(student: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.apiUrl}/students/${student}/certificates/export`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  getDiscountPrice(
    seriesId: string|null,
    bundleId: string|null,
    studentCount: number,
    personId: string|undefined = undefined,
    organisationId: string|undefined = undefined
  ): Observable<DiscountModel> {
    return this.http.post<DiscountModel>(this.resourceUrl + '/calculate_price', {
      series: seriesId,
      bundle: bundleId,
      studentCount,
      person: personId,
      organisation: organisationId
    });
  }
}
